export const transformDependentFromAPI = (apiDependent) => ({
    id: apiDependent.id,
    firstname: apiDependent.firstname,
    lastname: apiDependent.lastname,
    ssnItin: apiDependent.ssn_itin,
    dateOfBirth: apiDependent.date_of_birth,
    monthsLivedWith: String(apiDependent.months_lived_with),
    relationship:
      apiDependent.relationship === "qch"
        ? "qualifying_child"
        : apiDependent.relationship === "qre"
        ? "qualifying_relative"
        : apiDependent.relationship,
  });

export const transformDependentToAPI = (frontendDependent) => ({
    firstname: frontendDependent.firstname,
    lastname: frontendDependent.lastname,
    ssn_itin: frontendDependent.ssnItin,
    date_of_birth: frontendDependent.dateOfBirth,
    months_lived_with: frontendDependent.monthsLivedWith
      ? parseInt(frontendDependent.monthsLivedWith, 10)
      : 0,
    relationship:
      frontendDependent.relationship === "qualifying_child"
        ? "qch"
        : frontendDependent.relationship === "qualifying_relative"
        ? "qre"
        : frontendDependent.relationship,
  });
